import { useQuery } from '@tanstack/react-query';
import { labelQueueApi } from '../lib/labelQueueApi';

export function useLabelQueue() {
  return useQuery({
    queryKey: ['labelQueue'],
    queryFn: () => labelQueueApi.getQueue(),
  });
}

export function useLabelQueueCount() {
  return useQuery({
    queryKey: ['labelQueueCount'],
    queryFn: () => labelQueueApi.getQueueCount(),
  });
}
